import { useState, useEffect, useRef } from 'react';

const faqs = [
  {
    question: 'Onde posso comprar os sanduíches Naturalle?',
    answer: 'Você pode adquirir diretamente conosco via WhatsApp para consumo próprio ou revenda. Também fornecemos para supermercados, conveniências, lanchonetes, cantinas e academias em Fortaleza e região metropolitana.',
  },
  {
    question: 'Vocês fazem entrega?',
    answer: 'Sim! Trabalhamos com entregas por rota em Fortaleza, Maracanaú, Caucaia e Eusébio. Não cobramos taxa de entrega. Nossos entregadores saem às 07:00 e têm até às 17:00 para completar as entregas.',
  },
  {
    question: 'Como funciona para ser revendedor?',
    answer: 'O pedido mínimo é de 10 unidades, podendo escolher sabores variados. Aceitamos pagamento via Pix, dinheiro, transferência bancária ou boleto (após análise de crédito). Entre em contato pelo WhatsApp para iniciar.',
  },
  {
    question: 'Quais sabores vocês oferecem?',
    answer: 'Temos sanduíches de Atum, Filé de Frango com Milho, Filé de Frango com Requeijão e Peito de Peru, além de outras variedades. Todos com 140g e opções naturais, integrais e fitness.',
  },
  {
    question: 'Qual a validade dos sanduíches?',
    answer: 'Nossos sanduíches têm validade de 15 dias quando mantidos refrigerados entre 0°C e 10°C. Após aberto, consuma imediatamente para garantir a qualidade e frescor.',
  },
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.querySelectorAll('.reveal').forEach((el) => {
              el.classList.add('revealed');
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="faq"
      ref={sectionRef}
      className="relative py-20 md:py-28 bg-background-50"
    >
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="reveal inline-flex items-center gap-2 font-label text-xs md:text-sm text-accent-600 tracking-widest uppercase mb-4">
              <span className="w-6 h-px bg-accent-400" />
              Perguntas Frequentes
              <span className="w-6 h-px bg-accent-400" />
            </span>
            <h2 className="reveal reveal-delay-1 font-display text-3xl md:text-5xl text-foreground-900 leading-tight">
              Tire suas <span className="text-accent-600">dúvidas</span>
            </h2>
          </div>

          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={index}
                  className={`reveal rounded-2xl md:rounded-3xl border transition-all duration-300 overflow-hidden ${
                    isOpen
                      ? 'border-accent-200 bg-background-50 shadow-sm shadow-accent-100/10'
                      : 'border-background-200/60 bg-background-50 hover:border-background-300'
                  }`}
                  style={{ transitionDelay: `${index * 0.05}s` }}
                >
                  <button
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="w-full flex items-center justify-between px-5 py-4 md:px-6 md:py-5 text-left cursor-pointer"
                  >
                    <span className="font-heading text-sm md:text-base font-medium text-foreground-800 pr-4">
                      {faq.question}
                    </span>
                    <span
                      className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-all duration-300 ${
                        isOpen
                          ? 'bg-accent-500 text-white rotate-180'
                          : 'bg-background-100 text-foreground-400'
                      }`}
                    >
                      <i className="ri-arrow-down-s-line" />
                    </span>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-500 ${
                      isOpen ? 'max-h-60' : 'max-h-0'
                    }`}
                  >
                    <div className="px-5 pb-5 md:px-6 md:pb-6 pt-0">
                      <p className="font-body text-sm md:text-base text-foreground-500 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;